import React from 'react'

const DimensionContainer = ({ containerObject, templateName, contentId, dataZone }) => {
  return (
    <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row g-0 mx-3`} >
    <div className={`row dimension-name-container ${containerObject.attributes && containerObject.attributes.className ? containerObject.attributes.className :  ""}`}>
					<h2 class="dimension-name-title">{containerObject?.dimensionTitleName ?? ""}</h2>
				</div>
    </div>
  )
}

export default DimensionContainer